<template>
    <div class="mainLayout">
        <div class="lookup lookupDiv inner">

                <p class="innerTitle adminList">Reports</p>
                
                <div class="lookupResults scrollDivResults" >
                    <button v-bind:class="reportButtonClass(result.ID)" v-for="result in lookupResults" :key="result.ID" v-on:click="getReport(result.ID)">
                        {{result.Name}}
                    </button>  
                </div>
                
                <div class="paramdiv">
                    <div class="vertFlex" v-for="param in userParameters" :key="param.ID" >
                        <p class="editLabel">{{param.Name}}</p>
                        <input class="editText" :type="paramInputType(param)" v-if="!paramIsSelect(param)" v-model="param.CurrentValue"/>
                        <select name="" id="" class='lookupSelect'  v-if="paramIsSelect(param)" v-model="param.CurrentValue">
                            <option v-for="opt in param.Values" :key="opt.ID" :value="opt.ID" >
                                {{opt.Name}}
                            </option>
                        </select>
                    </div>
                    
                </div>
                <div class="wait" v-show="pleaseWait">
                    <label for="">Please Wait...</label>
                </div>
                <div class="error" v-if="!errorMessage==null">
                    <label for="">{{errorMessage}}</label>
                </div>
                <div class="reportButtonDiv" v-if="!pleaseWait">
                    
                    <button class="gobutton" v-on:click="generateReport()" :disabled="!isSelectedResult" >View</button>
                    <hr>
                    <br>
                    <reportscheduler/>
                </div>
            
        </div>
        
        
        <div class="main">
            <div class="reportView ">
                <div class="horizFlexStretch" v-if="reportURL!='' && !showEmail">
                    <p class="innerTitle adminList">{{selectedResult.Name}}</p>
                    <div class="horizFlex">
                        <a :href="reportURL" target="_blank" class="reportLink">
                            <button class="emailbutton" >Download PDF</button>
                        </a>
                        <a :href="excelURL" target="_blank" class="reportLink" v-if="excelURL!=''">
                            <button class="emailbutton" >Download Excel</button>
                        </a>
                        <button class="emailbutton" v-on:click="emailReport()" >Send Email</button>
                    </div>
                    
                    

                </div>
                <div class="emailPanel" v-if="showEmail">
                    <p class="innerTitle adminList">Send Email</p>
                    <p class="emailLabel">Subject:</p>
                    <input type="text" class="emailText" v-model="emailSubject">
                    <p class="emailLabel">Send to the following email addresses (separate multiple by ;):</p>
                    <input type="text" class="emailText" v-model="emailToAddresses" >
                    <div class="horizFlex emailRadioDiv">
                        
                            <input type="radio" class="emailRadio" value="pdf" v-model="emailReportType" name="reporttype">
                            <p class="emailRadioLabel"  >PDF</p>
                        
                            <input type="radio" class="emailRadio" value="csv" v-model="emailReportType"  name="reporttype">
                            <p class="emailRadioLabel" >CSV</p>
                         
                        
                            
                        
                    </div>
                    
                    <button class="goEmailButton" v-on:click="sendEmailReport()" >Send</button>
                </div>
                <div class="emailPanel horizFlex" v-if="showEmailConfirmation">
                    <p class="innerTitle adminList">Email Sent Successfully</p>
                    <button class="emailbutton" v-on:click="closeEmailConfirm()" >Close</button>
                </div>
                <div class="scrollDivReport">
                    <iframe :src="reportURL" frameborder="0" height="100%" width="100%" class="reportFrame">
                    </iframe>
                </div>
                
                <!-- <object :data="reportURL" type="application/pdf">
                <embed :src="reportURL" height="200" width="200" type="application/pdf"/>
                </object> -->
            </div>
        </div>
            
    </div>

  
</template>

<script>
import {ReportHTTP} from '../Repository'
import reportscheduler from './actions/ReportScheduler.vue'
import tokenhelper from '../tokenhelper.js'
export default {
    mixins:[tokenhelper],
    components:{
        reportscheduler
    },
    data(){
        return{
            locationID:1,
            pleaseWait:false,
            imageBasePath:'',

            lookupResults:{},
            selectedResult:{},
            instance:{},
            reportURL:'',
            excelURL:'',
            showEmail:false,
            showEmailConfirmation:false,
            emailSubject:'Please see attached report',
            emailToAddresses:'',
            emailPDF:true,
            emailCSV:false,
            emailReportType:'pdf',
            errorMessage:''
        }
    },
    mounted(){
        this.lookup();
        this.getImageBasePath()
    },
    methods:{
        AddTokenToAPI(){
            var token = this.getToken()   
            HTTP.defaults.headers.post['token']=token
        },
        getImageBasePath(){
            this.pleaseWait=true;
          
            ReportHTTP.post('reportimagepath')
            .then(response=>{
                this.imageBasePath = window.VUE_CONFIG_ReportAPI + response.data.StringResponse
                console.log("got imagepath " + this.imageBasePath)
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e

            });
        },
        paramInputType(param){
            switch(param.ControlType){
                case 3:
                    return "date"
                    break;
                
                default:
                    return "text"
                    break;
            }

        },
        paramIsSelect(param){
            if(param.ControlType=="2"){
                return true;
            }else{
                return false
            }
        },
        reportButtonClass(reportID){
            if(reportID==this.selectedResult.ID){
                
                return "adminButtonSelected"
            }else{
                return "adminButton"
            }    
        },
        lookup(){
            let req = {
                SalonID:this.locationID,
                ReportTypeID:-1
            }
            this.pleaseWait=true;
            
            ReportHTTP.post('reportlist',req)
            .then(response=>{
                this.lookupResults = response.data.ReportList
                this.pleaseWait=false;
                console.log(response)
            })
            .catch(e=>{
                this.pleaseWait=false;
                if(e.message=='Network Error'){
                    this.errorMessage = "Report Error: Cannot Reach API"
                }
                this.errorMessage = "Report Error: " + e.message;

                console.log(e)
                return e
            });
            
        },
        setDates(){
            console.log('setdates')
            this.selectedResult.Parameters.forEach(myFunction2)
            
            function myFunction2(item, index, arr) {
                let param=arr[index]
                console.log('controltype ' + param.ControlType)
                if(param.ControlType==3){
                    console.log(param.CurrentValue)

                    var t= new Date(param.CurrentValue);

                    var dd = String(t.getDate()).padStart(2, '0');
                    var mm = String(t.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var yyyy = t.getFullYear();

                    param.CurrentValue=yyyy + '-' + mm + '-' + dd
                }

            } 
        },
        getReport(reportID){
            this.errorMessage='';

            let req = {
                ReportID:reportID,
                SalonID:1
            }
            this.pleaseWait=true;
         
            ReportHTTP.post('report',req)
            .then(response=>{
                this.selectedResult = response.data.Report
                this.setDates();
                this.isSelectedResult=true;
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });
            
        },
        generateReport(){
           console.log('in gen') 
            this.errorMessage='';
            
            let req = {
                Report:this.selectedResult
            }
            console.log(req)
            this.pleaseWait=true;
        
            ReportHTTP.post('generate',req)
            .then(response=>{
                console.log(response.data)
                if(response.data.Successful){
                    this.instance = response.data.Instances[0]
                    //this.reportURL = 'https://docs.google.com/viewerng/viewer?url='+this.imageBasePath + response.data.Instances[0].ExportPath+'&embedded=true'
                    this.reportURL = this.imageBasePath + response.data.Instances[0].ExportPath
                    this.isSelectedResult=true;
                    this.pleaseWait=false;
            
                    this.generateExcel();
                }else{
                    this.pleaseWait=false;
                    this.errorMessage = "Report Failed :" + response.data.RequestException.Message;
                }
                
            })
            .catch(e=>{
                console.log(e)
                this.errorMessage="Report Failed :" + e.message;
                this.pleaseWait=false;
                return e
            });
            
        },
        generateExcel(){
           console.log('in genex') 

            let req = {
                ReportInstance:this.instance
            }
            console.log(req)
            this.pleaseWait=true;
            
            ReportHTTP.post('excel',req)
            .then(response=>{
                console.log(response.data)
                this.excelURL = this.imageBasePath + response.data.StringResponse
                this.isSelectedResult=true;
                this.pleaseWait=false;
            })
            .catch(e=>{
                console.log(e)
                this.pleaseWait=false;
                return e
            });
            
        },
        emailReport(){
            this.showEmail=true;
        },
        sendEmailReport(){
            console.log('in email') 

            //determine which report to take
            var urlToSend=''
            if(this.emailReportType=="pdf"){
                urlToSend=this.reportURL
            }else{
                urlToSend=this.excelURL
            }

            let req = {
                subject:this.emailSubject,
                message:this.emailSubject,
                toAddresses:this.emailToAddresses,
                attachPath:urlToSend
            }
            console.log(req)
            this.pleaseWait=true;
            
            ReportHTTP.post('email',req)
            .then(response=>{
                console.log(response.data)
                this.showEmail=false;
                this.showEmailConfirmation=true;
                this.pleaseWait=false;
            })
            .catch(e=>{
                console.log(e)
                this.pleaseWait=false;
                return e
            });



        },
        closeEmailConfirm(){
            this.showEmailConfirmation=false;
        },
        formatDateForInputToday(){

            var t= new Date();

            var dd = String(t.getDate()).padStart(2, '0');
            var mm = String(t.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = t.getFullYear();

            return yyyy + '-' + mm + '-' + dd
        },
        formatDateForInput(dateString){
            console.log('date ' + datestring)
            var t= new Date(dateString);

            var dd = String(t.getDate()).padStart(2, '0');
            var mm = String(t.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = t.getFullYear();

            return yyyy + '-' + mm + '-' + dd
        },
    },
    computed:{
        userParameters(){    
            let tempUsers = this.selectedResult.Parameters
            if(tempUsers!=undefined){
                tempUsers = tempUsers.filter((item)=>{
                    return (item.UserMayEnter)
                })
                return tempUsers
            }
                
        },
        
    }
}
</script>

<style scoped>

.wait{
    font-size:large;
    color:rgb(238,120,45);
    padding:20px;
}
.error{
    font-size:medium;
    color:red;
    padding:20px;
}
/* main */
.mainLayout{
    display:grid;
    grid-template-columns:1fr 3fr;
    grid-template-rows:1fr 3fr;
    grid-template-areas: 
    "lookup main"
    "lookup main";
}
/*areas*/
.lookup{
    grid-area:lookup;
}
.main{
    grid-area:main;   
}
.reportView{
    height:100%;
}
.detail{
    grid-area:detail; 
}
.scrollDiv{
    height:320px;
    overflow-x:hidden;
    overflow-y:scroll;
}
.inner{
    border-radius:10px; 
    margin:10px;
    padding:0px;
    text-align: left;
    background-color: white;
}
.innerInactive{
    background-color: lightgray;
}
.innerTitle{
    font-size:x-large;
    color:rgb(0,158,192);
}
.emailPanel{
    border-radius:10px; 
    margin:10px;
    padding:5px;
    text-align: left;
    background-color: white;
}
.horizFlex{
  display:flex;
  flex-direction: row;
  
}
.horizFlexStretch{
    display:flex;
  flex-direction: row;
  justify-content: space-between;
}
.vertFlex{
  display:flex;
  flex-direction: column;
  margin:5px;
}
.linkButton{
  background-color: transparent;
  color: rgb(0,158,192);
  font-size:small;
  border:none;
  padding:0px;
}
.linkButtonMedium{
  font-size:medium;
  
}

.adminButton{
    grid-area:add;
    background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 200px;
   height:50px;
   margin-top:10px;
   margin-left:10px;

}
.adminButtonSelected{
    grid-area:add;
    background-color:rgb(196, 218, 226);
   color:rgb(0,158,192);
   padding:10px;
   border-radius:20px;
   border:solid;
   border-color:rgb(238,120,45);
   font-size:inherit;
   width: 200px;
   height:50px;
   margin-top:10px;
   margin-left:10px;
    font-weight:bold;
}
.fileBrowse{
    margin-right:20px;

}
.ieButton{
 
    background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 100px;
   height:35px;
   margin-top:20px;
   margin-right:20px;
   margin-left:10px;
}
.adminList{
    margin-left:10px;
}
.editText{
    height:20px;
    margin-top:0px;
    margin-left:10px;
    margin-bottom:10px;
    width:90%;
    font-style:inherit;
    font-family:inherit;
    font-size:inherit;
}
.emailText{
    height:20px;
    margin-top:0px;
    margin-right:10px;
    margin-bottom:10px;
    width:450px;
    margin-left:40px;
    font-style:inherit;
    font-size:inherit;
}
.emailRadio{
    margin-top:15px;
    margin-right:5px;
    margin-left:10px;

}
.emailRadioDiv{
    margin-left:40px;
}
.emailLabel{
    margin-left:40px;
    width:450px;
    margin-bottom:5px;
}
.editTextDesc{
    width:400px;
    
}
.editLabel{
    margin-left:10px;
    width:200px;
    margin-top:0px;
    margin-bottom:0px;
}
.paramdiv{
    margin-top:20px;
}
.reportButtonDiv{
    margin-top:5px;
    text-align: left;
}
.gobutton{
    background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
  margin-bottom:20px;
  margin-left:5px;
   width: 120px;
}
.goEmailButton{
    background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
  margin-bottom:20px;
  margin-left:40px;
   width: 100px;
}
.emailbutton{
    background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
  margin:10px;
   width: 100px;
}
/*security*/
.security{
    display:grid;
    grid-template-columns:1fr 2fr;
    grid-template-areas: 
    "groups rights";
}
.secGroups{
    grid-area:groups;
    padding:10px;
    text-align: center;
}
.secRights{
    grid-area:rights;
    padding:10px;
}
/*lookup*/
.lookupDiv{
    grid-area:lookup;
    height:78vh;
    padding-left:10px;
    padding-right:10px;
}

.lookupText{
    border-width: 1;
    border-color:darkgray;
    border-radius: 5px;
    font-size:inherit;
    width:160px;
}

.lookupGo{
    background-color: rgb(238,120,45);
    border:none;
    border-radius:5px;
    margin-left:3px;
    color:white;
}
.lookupSelect{
  outline-color:rgb(238,120,45);
  outline-width:2px;
  border-radius: 5px;
  font-size:inherit;
  width:245px;
  margin-bottom:5px;
  margin-left:10px;
  
}

.lookupResults{
    padding:0px;
    margin-top:10px;
}
.resultButton{
    width:96%;
    margin:5px;
    background-color:rgb(196, 218, 226);
    border:none;
    border-radius:10px;
    padding:10px;
    color:rgb(0,158,192);
    font-size:medium;
}
.resultButton:focus{
    /* color:rgb(238,120,45); */
    font-weight:bold;
    outline-style:none;
    border-color:rgb(238,120,45);
    border-width:2px;
    border-style:solid;
}
/* personcard */
.personCard{
    display:grid;
    grid-template-columns:600px auto 120px;
    grid-template-rows:auto;
    grid-template-areas: 
    "address space personaction";
}
.personPhoto{
    grid-area:photo;
}
.image{
    margin:20px;
}
.personAddress{
    grid-area:address;
    display:flex;
    flex-direction: column;
    justify-content:flex-start;
    margin-left:10px;
}
.personAction{
    grid-area:personaction;
    display:flex;
    flex-direction: column;
    text-align: center;
}
.locationtitle{
    color:rgb(0,158,192);
}
.personName{
    font-size:xx-large;
    font-weight:bold;
    color:rgb(0,158,192);
    margin-bottom:5px;
    margin-top:10px;
}
.textlistdiv{
    text-align:left;
}
.textlist{
    list-style-type:none;
    padding-left:0;
    margin-right:60px;
}
.paidmain{
    color:green;
    font-size:large;
    margin-top:20px;
    margin-left:30px;
}
.unpaidmain{
    color:red;
    font-size:large;
    margin-top:20px;
    margin-left:30px;
}
.paid{
    color:green;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.unpaid{
    color:red;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.inactive{
    color:rgb(53, 48, 48);
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
/* club item */
.itemDetailOpen{
    display:grid;
    grid-template-columns:300px auto 40px 120px;
    grid-template-rows:1fr 1fr;
    grid-template-areas: 
    "clubtitle space paid action"
    "clubdate space paid action";
    height:140px;
}
.itemDetail{
    display:grid;
    grid-template-columns:300px auto 40px 120px;
    grid-template-rows:1fr;
    grid-template-areas: 
    "clubtitle space paid action";
}
.itemSpace{
    grid-area:space;
    text-align:center;
    display: flex;
    flex-direction: column-reverse;
}
.clubTitle{
    grid-area:clubtitle;
    margin-left:10px;
}
.clubDate{
    margin-left:10px;
}
.titleGrid{
    display:grid;
    grid-template-columns:200px auto 100px 100px;
    grid-template-rows:1fr 1fr 1fr;
    grid-template-areas: 
    "maintitle space paid action"
    "address1 phone paid action"
    "address2 email paid action";
}
.itemAction{
    grid-area:action;
    display:flex;
    flex-direction: column;
    text-align: center;
}

/* itemtitle */
.itemTitleBar{
    display:grid;
    grid-template-columns:700px  auto 150px 110px;
    grid-template-rows:auto;
    grid-template-areas: 
    "title  space inactive add";
    margin-left:10px;
    margin-right:10px;
  
}
.itemTitle{
    grid-area:title;
    
}
.itemBarTitle{
    font-size:x-large;
    /* color:rgb(0,158,192); */
    color:rgb(0,158,192);
    font-weight: bold;
}
.itemBarSubTitle{
    font-size:large;
    color:rgb(0,158,192);
    /* color:rgb(0,158,192); */
    margin-top:30px;
    margin-left:30px;
}
.inactiveCheck{
    grid-area:inactive;
    margin-top:30px;
    color:rgb(0,158,192);
}
.addButton{
    grid-area:add;
    background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 120px;
   height:40px;
   margin-top:20px;
   margin-right:20px;
}


.button{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 0px 20px;
   width: 85px;
}

.buttonPerson{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 5px 20px;
   width: 85px;
}
button:disabled{
  background-color:gray;
}

.innerTransparent{

    padding:0px;
    text-align: left;

}


.scrollDivResults{
    height:40%;
    overflow-x:hidden;
    overflow-y:scroll;
}
.scrollDivReport{
    height:86%;
    overflow-x:hidden;
    overflow-y:scroll;
}

.reportFrame{
    background-color:rgb(196, 218, 226);
    margin:20px;
}


</style>

